import { Empty, Input, Space, Spin } from 'antd';
import { BasePageComponent } from 'components';
import React, { useMemo, useState } from 'react';
import { useSeasonList } from 'hooks/useSeason';
import { useVendorAssignedSeasonIds } from 'hooks/useVendorAssignedSeasons';
import { SeasonCard } from '../components/SeasonCard';

export const VendorDownloadListPage: React.FC = () => {
  const [search, setSearch] = useState('');

  const { seasonIds, isLoading: idsLoading } = useVendorAssignedSeasonIds();

  const params = useMemo(() => {
    const p = new URLSearchParams();
    p.set('page', '1');
    p.set('page_size', '100');
    if (seasonIds.length > 0) p.set('ids', seasonIds.join(','));
    return p;
  }, [seasonIds]);

  const { data, isFetching: seasonsLoading } = useSeasonList(params, {
    enabled: seasonIds.length > 0,
  });

  const filtered = useMemo(() => {
    const results = data?.results ?? [];
    if (!search) return results;
    const q = search.toLowerCase();
    return results.filter(s => (s.title || s.slug || '').toLowerCase().includes(q));
  }, [data, search]);

  const loading = idsLoading || seasonsLoading;
  const hasAssignment = !idsLoading && seasonIds.length > 0;

  return (
    <BasePageComponent>
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        <Space wrap>
          <Input.Search
            placeholder="Search season title"
            allowClear
            onSearch={setSearch}
            style={{ width: 320 }}
          />
        </Space>

        {loading && (
          <div style={{ textAlign: 'center', padding: 48 }}>
            <Spin />
          </div>
        )}

        {!loading && !hasAssignment && (
          <Empty description="No seasons assigned to your account" />
        )}

        {!loading && hasAssignment && filtered.length === 0 && (
          <Empty description="No seasons match the search" />
        )}

        {!loading && filtered.length > 0 && (
          <Space wrap size={[16, 16]}>
            {filtered.map(season => (
              <SeasonCard key={season.id} season={season} />
            ))}
          </Space>
        )}
      </Space>
    </BasePageComponent>
  );
};
